<template>
	<!-- 分析师列表 -->
	<div class="analyst">
		<MStateBox :loading="analyst.loading" :empty="isEmpty">
			<el-table :data="analystData" class="el-table--v-slide">
				<el-table-column
					prop="institution"
					:label="i18n.t('enterprise.company')"
					min-width="120"
					show-overflow-tooltip
				></el-table-column>
			<el-table-column :label="i18n.t('enterprise.analyst')">
				<template #default="{ row }">
					<div class="text-wrap">{{ row.name }}</div>
				</template>
			</el-table-column>
			<el-table-column :label="i18n.t('enterprise.contact')">
				<template #default="{ row }">
					<div class="text-wrap">{{ row.mail }}</div>
				</template>
			</el-table-column>
			</el-table>
		</MStateBox>
		<div class="statement">
			<p>*{{ statementText }}</p>
			<p>*{{ translatedText }}</p>
		</div>
	</div>
</template>

<script setup>
import { onMounted, computed } from 'vue';
import { useModuleData } from '@rebuild/hooks/data/useModuleData';
import i18n from '@/locales';
import MStateBox from '@rebuild/components/MStateBox.vue';
import { useAnalystCore } from '@rebuild/materials/shared/analyst/context';

const { translatedText, statementText } = useAnalystCore();
const { analyst } = useModuleData();

// 统一的数据计算属性，避免重复取值，处理不同API的数据格式
const analystData = computed(() => {
	// slide 模板返回 data.data，标准模板返回 data.rows
	return analyst.data?.data || [];
});

const isEmpty = computed(() => {
	return analyst.empty || !analystData.value.length;
});

const refresh = async () => {
	await analyst.refresh({
		slideTmpl: true // 通过参数标识使用不同的API逻辑
	});
};


onMounted(() => {
	refresh();
});
</script>
<style lang="less" scoped>
.statement {
	margin-top: 32px;
	background: var(--fill-normal-color, #f2f3f5);
	padding: 10px;

	color: var(--t-secondary-info-color, #86909c);

	font-size: 12px;

	font-weight: 400;
	line-height: 24px;
}

.text-wrap {
	white-space: pre-line; // 保留换行符，但合并多余空格
}
</style>
